import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Custom from "./views/Custom.vue";
import FeelingLucky from "./views/FeelingLucky.vue";
import CompletedDesign from "./views/CompletedDesign.vue";
import Introduction from "./views/Introduction.vue";
import NotFound from "./views/NotFound.vue";
import LocaleView from "./views/LocaleView.vue";

import ConfigureText from "./components/configure/Text.vue";
import ConfigureFabric from "./components/configure/Fabric.vue";
import ConfigureCaps from "./components/configure/Caps.vue";
import ConfigureIcons from "./components/configure/Icons.vue";
import ConfigureSpine from "./components/configure/Spine.vue";
import ConfigureLoop from "./components/configure/Loop.vue";
import ConfigurationCanvas from "./components/ConfigurationCanvas.vue";
import ConfigurationCanvasRotator from "./components/ConfigurationCanvasRotator.vue";
import CompletedProductText from "./components/completed/CompletedProductText.vue";

import ImageAndButton from "./components/feelingLucky/ImageAndButton.vue";
import Description from "./components/feelingLucky/Description.vue";

const defaultLocale = "en-us";
const localeRegex = /^[a-z][a-z]-[a-z][a-z]$/;

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: `/${defaultLocale}`,
    },
    {
      path: "/404",
      component: NotFound,
    },
    {
      path: "/:locale",
      component: LocaleView,
      children: [
        {
          path: "/",
          name: "home",
          component: Home,
        },
        {
          path: "intro",
          name: "Intro",
          component: Introduction,
        },
        {
          path: "configure",
          name: "custom",
          component: Custom,
          children: [
            {
              path: "text",
              name: "CustomText",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureText,
              },
              props: {
                canvas: {
                  emphasizedView: "front",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
            {
              path: "fabric",
              name: "Fabric",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureFabric,
              },
              props: {
                canvas: {
                  emphasizedView: "front",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
            {
              path: "caps",
              name: "Caps",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureCaps,
              },
              props: {
                canvas: {
                  emphasizedView: "front",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
            {
              path: "icons",
              name: "Icon",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureIcons,
              },
              props: {
                canvas: {
                  emphasizedView: "front",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
            {
              path: "spine",
              name: "Spine",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureSpine,
              },
              props: {
                canvas: {
                  emphasizedView: "back",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
            {
              path: "loop",
              name: "Loop",
              components: {
                canvas: ConfigurationCanvas,
                canvasOptions: ConfigureLoop,
              },
              props: {
                canvas: {
                  emphasizedView: "back",
                  suffix: "design",
                  slideTransition: true,
                },
              },
            },
          ],
        },
        {
          path: "configure/completed",
          component: CompletedDesign,
          children: [
            {
              path: "",
              name: "completed-design",
              components: {
                canvas: ConfigurationCanvasRotator,
                completed: CompletedProductText,
              },
              props: {
                canvas: {
                  addToCartPage: true,
                },
              },
            },
          ],
        },
        {
          path: "feeling-lucky",
          component: FeelingLucky,
          children: [
            {
              path: "",
              name: "feeling-lucky",
              components: {
                speaker: ImageAndButton,
                description: Description,
              },
              props: {
                speaker: {
                  showButton: true,
                },
              },
            },
            {
              path: ":id",
              name: "SpeakerChoices",
              components: {
                speaker: ImageAndButton,
                description: Description,
              },
              props: {
                speaker: {
                  showButton: true,
                },
                description: {
                  buttons: true,
                },
              },
            },
            {
              path: ":id/text",
              name: "SpeakerText",
              components: {
                speaker: ConfigurationCanvas,
                description: Description,
              },
              props: {
                speaker: {
                  hotspots: false,
                  emphasizedView: "equal",
                  alwaysShowFullSpeaker: true,
                  mobileOrientation: "sideways",
                  labelsPosition: "bottom",
                  suffix: "text",
                },
                description: {
                  enterText: true,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log(to, from);
  // if there is a locale, we're fine. otherwise, we need to add one to the url
  if (to.path === "/404" || to.path.split("/")[1].match(localeRegex)) {
    // either we are a 404 or we have a locale already
    console.log(to.path.split("/")[1], "locale?");
    console.log("we are either a 404 or we have a locale");
    console.log(to, "to");
    if (
      (to.path.split("/")[1] === "en-au" ||
        to.path.split("/")[1] === "en-gb") &&
      to.name !== "home"
    ) {
      next({
        path: `/${to.path.split("/")[1]}`,
      });
    } else {
      next();
    }
  } else {
    // need to add a locale - assume en-us?
    console.log("no matchy");
    next({
      path: `${defaultLocale}${to.path}`,
      query: to.query,
    });
  }
});

export default router;
